<!--
 * @Author: your name
 * @Date: 2022-04-29 17:22:33
 * @LastEditTime: 2022-06-27 10:59:28
 * @LastEditors: shijianchen shijianchen@tujia.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/volvo202204/components/gotomini.vue
-->
<template>
  <div v-if="path" class="miniBox">
    <img class="img" :src="src" alt="" />
    <wx-open-launch-weapp
      v-if="isBrowser()"
      id="launch-btn"
      style="position:relative;z-index:10;"
      username="gh_c311aa55d273"
      :path="path"
    >
      <script type="text/wxtag-template">
        <span style="width:100vw;height:484px;display:block;position:relative;z-index:100;" class="jumpToMini">
        </span>
      </script>
    </wx-open-launch-weapp>
    <span v-if="!isBrowser()" @click="gotomini"
      style="width: 100vw; height: 484px; display: block;position:relative;z-index:100;"
      class="jumpToMini"
    >
    </span>
  </div>
</template>

<script>
export default {
  props: ["src","path"],
  mounted() {
    try {
      // var btn = document.getElementById("launch-btn");
      // btn.addEventListener("launch", (e) => {
      //   this.addTime();
      // });
    } catch (error) {}
  },
  methods: {
    gotomini() {
      location.href =
        window.hysdk.sniff.scheme +
        "://miniprogram/launchMiniProgram?userName=gh_c311aa55d273&path="+encodeURIComponent(this.path);
    },
    isBrowser() {
      if (window.hysdk.sniff.scheme) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="less" scoped="true">
.miniBox {
  position: relative;
  height: 484px;
}
.img {
  position: absolute;
  left: 0;
  top: 0;
  height: 484px;
  border-radius: 10px;
}
#launch-btn {
  width: 315px;
}
</style>